import {Theme} from "@core-ui/react-stitch";
import {
  ComposableButtonInteractiveConfig,
  ComposableButtonBaseProps,
  Variant,
} from "../../types";
import {getActiveButtonColor} from "../../styles/helpers";

const athletaInteractiveStylesConfig = (
  props: Partial<ComposableButtonBaseProps> & {theme: Theme}
): ComposableButtonInteractiveConfig => {
  const {primary, secondary} = getActiveButtonColor(props);

  return {
    hoverFocus: {
      [Variant.border]: {
        "&:hover, &:focus": {
          color: secondary,
          backgroundColor: primary,
          borderColor: primary,
        },
      },
      [Variant.chevron]: {
        "span:hover, span:focus": {
          color: secondary,
          backgroundColor: primary,
          "& span svg": {
            fill: secondary,
          },
        },
      },
      [Variant.flat]: {
        "&:hover, &:focus": {
          textDecoration: "underline",
        },
      },
      [Variant.solid]: {
        "&:hover, &:focus": {
          color: primary,
          backgroundColor: secondary,
          borderColor: secondary,
        },
      },
      [Variant.outline]: {
        "&:hover, &:focus": {
          color: secondary,
          backgroundColor: primary,
          borderColor: primary,
        },
      },
      [Variant.underline]: {
        "span:hover, span:focus": {
          color: secondary,
          backgroundColor: primary,
          "& span svg": {
            fill: secondary,
          },
        },
      },
    },
    active: {
      [Variant.border]: {
        "&:active": {
          textDecoration: "underline",
          color: primary,
          backgroundColor: secondary,
          borderColor: primary,
        },
      },
      [Variant.chevron]: {
        "span:active": {
          color: secondary,
          backgroundColor: primary,
          "& span svg": {
            fill: secondary,
          },
        },
      },
      [Variant.flat]: {
        "&:active": {
          textDecoration: "underline",
        },
      },
      [Variant.solid]: {
        "&:active": {
          textDecoration: "underline",
          color: secondary,
          backgroundColor: primary,
          borderColor: primary,
        },
      },
      [Variant.outline]: {
        "&:active": {
          textDecoration: "underline",

          color: primary,
          backgroundColor: "transparent",
          borderColor: primary,
        },
      },
      [Variant.underline]: {
        "span:active": {
          color: secondary,
          backgroundColor: primary,
          "& span svg": {
            fill: secondary,
          },
        },
      },
    },
  };
};

export default athletaInteractiveStylesConfig;
